<template>
  <div class="h-[40px] flex items-center gap-[5px]">
    <b-button
      :variant="disabledMinus ? 'outline-secondary' : 'outline-primary'"
      class="p-0 !w-[28px] !h-[28px] !min-w-[28px] !rounded-full flex items-center justify-center flex-shrink-0"
      size="sm"
      :disabled="disabledMinus"
      @click="decreaseTotal"
    >
      <span class="font-bold text-base leading-none">−</span>
    </b-button>
    <b-input
      v-model.number="total"
      number
      :max="maxStock"
      class="text-center min-w-[80px]"
      :formatter="totalFormatter"
    />
    <b-button
      :variant="disabledPlus ? 'outline-secondary' : 'outline-primary'"
      class="p-0 !w-[28px] !h-[28px] !min-w-[28px] !rounded-full flex items-center justify-center flex-shrink-0"
      size="sm"
      :disabled="disabledPlus"
      @click="increaseTotal"
    >
      <span class="font-bold text-base leading-none">+</span>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'TotalItemCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    variantIndex: {
      type: Number,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      total: 0,
    }
  },
  computed: {
    isVariant() {
      return this.variantIndex !== undefined && (this.data.item?.variants?.length ?? 0) > 0
    },
    variantData() {
      if (this.isVariant) {
        return this.data.item.variants[this.variantIndex]
      }
      return undefined
    },
    maxStock() {
      if (this.isVariant) {
        return this.variantData?.stock || 0
      }
      return this.data.item?.stock || 0
    },
    disabledMinus() {
      return this.total <= 0
    },
    disabledPlus() {
      return this.total >= this.maxStock
    },
  },
  watch: {
    total(newValue) {
      this.$emit('new-value', newValue)
    },
  },
  methods: {
    decreaseTotal() {
      if (this.total > 0) {
        this.total -= 1
      }
    },
    increaseTotal() {
      if (this.total < this.maxStock) {
        this.total += 1
      }
    },
    totalFormatter(value) {
      const newValue = value ? value?.replace(/[^\d]/g, '').slice(0, 4) : 0
      return Math.max(0, Math.min(newValue, this.maxStock))
    },
    setTotalValue(value) {
      this.total = value
    },
  },
}
</script>
